import controller from './procedure-detail.controller';
import templateBase from './views/procedure-detail.view.t1.html';
import templateAD from './views/procedure-detail.adaptative.html';

let ProcedureDetailComponent = {
  template:changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

function changeTemplate() {
  if(__env.adaptative){
    return templateAD;
  } else {
    return templateBase;
  }
}

export default ProcedureDetailComponent;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/procedure-detail/procedure-detail.component.js
 **/